export enum CountryCode {
    France = 'FR',
    Spain = 'ES',
    UnitedStates = 'US',
}
